import Component from './alert.component';

export default Component;
